module.exports = __webpack_public_path__ + "static/media/LowSetupCost.df65e516.svg";